import RHFDictionary from '../RHFDictionary';
import { useSitesShopCategories } from 'iomart-hooks';
import type { Columns } from 'src/@types/common';

const DICTIONARY_COLUMNS: (Columns & { minWidth?: number; maxWidth?: number })[] = [
  {
    name: 'name',
    subname: 'slug',
    label: 'Name',
    align: 'left',
    nameLines: 1,
    subNameLines: 1,
    minWidth: 160,
    width: 240,
    maxWidth: 320,
  },
];

type RHFSitesShopCategoriesProps = {
  name: string;
  label?: string;
  multiple?: boolean;
  disabled?: boolean;
  /** ID сайта — для фильтрации категорий (если не задан, список может быть пустым) */
  siteId?: number;
  /** Ширина Drawer справочника */
  drawerWidth?: Record<string, string | number>;
};

export default function RHFSitesShopCategories({
  name,
  label = 'Category',
  multiple = false,
  disabled,
  siteId,
  drawerWidth = { xs: '100%', sm: 480 },
}: RHFSitesShopCategoriesProps) {
  const filters = siteId != null ? { site_id: siteId } : {};

  return (
    <RHFDictionary
      name={name}
      label={label}
      useHook={useSitesShopCategories}
      columns={DICTIONARY_COLUMNS}
      multiple={multiple}
      optionsLabel="name"
      getOptionLabel={(opt: any) => opt?.name || `#${opt?.id}` || ''}
      searchName="name"
      pageSize={10}
      disabled={disabled}
      filters={filters}
      drawerWidth={drawerWidth}
    />
  );
}
